import { ComponentPropsWithoutRef } from 'react';

export function Code404(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg width="876" height="1117" viewBox="0 0 876 1117" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M277.709 538.227V572.924H243.754V631H207.016V572.924H73.6074V548.246L170.092 364.926H211.098L119.623 538.227H207.016V456.215H243.754V538.227H277.709Z"
        fill="#9E8AD9"
      />
      <path
        d="M439.978 629.605C418.34 629.585 397.06 623.95 378.123 613.227C359.186 602.504 343.21 587.04 331.684 568.28C320.159 549.52 313.46 528.075 312.213 505.946C310.966 483.816 315.211 461.723 324.553 441.729C325.285 440.151 326.599 438.934 328.205 438.347C329.812 437.761 331.581 437.851 333.123 438.599C334.664 439.347 335.853 440.692 336.428 442.338C337.002 443.983 336.916 445.795 336.187 447.375C328.624 463.298 324.747 480.792 324.859 498.5C324.859 521.9 331.636 544.774 344.333 564.226C357.03 583.678 375.075 598.834 396.184 607.774C417.293 616.714 440.516 619.038 462.915 614.45C485.314 609.862 505.88 598.569 522.01 582.001C538.14 565.432 549.109 544.334 553.528 521.376C557.947 498.418 555.618 474.633 546.834 453.032C538.051 431.431 523.21 412.985 504.188 400.03C485.166 387.074 462.82 380.192 439.978 380.254C416.914 380.113 394.364 387.229 375.377 400.642C373.956 401.598 372.222 401.937 370.557 401.584C368.892 401.231 367.432 400.215 366.498 398.76C365.564 397.304 365.233 395.528 365.577 393.822C365.922 392.116 366.914 390.62 368.335 389.664C387.615 376.413 410.045 368.775 433.233 367.565C456.419 366.354 479.492 371.617 499.986 382.791C520.481 393.965 537.629 410.632 549.6 431.01C561.572 451.389 567.916 474.715 567.955 498.5C567.867 533.243 554.355 566.537 530.374 591.104C506.392 615.672 473.893 629.514 439.978 629.605Z"
        fill="#9E8AD9"
      />
      <path
        d="M439.96 601.695C420.038 601.695 400.563 595.643 383.998 584.304C367.434 572.965 354.523 556.849 346.899 537.994C339.275 519.138 337.28 498.39 341.167 478.373C345.054 458.356 354.647 439.969 368.734 425.537C382.821 411.106 400.77 401.278 420.309 397.296C439.848 393.315 460.102 395.358 478.507 403.168C496.913 410.979 512.645 424.205 523.713 441.174C534.782 458.144 540.689 478.095 540.689 498.504C540.691 499.37 540.526 500.228 540.204 501.029C539.881 501.83 539.408 502.557 538.81 503.17C538.213 503.783 537.505 504.269 536.723 504.601C535.942 504.933 535.105 505.104 534.26 505.104C533.414 505.104 532.577 504.933 531.797 504.601C531.016 504.269 530.306 503.783 529.709 503.17C529.111 502.557 528.638 501.83 528.316 501.029C527.993 500.228 527.829 499.37 527.83 498.504C527.83 480.701 522.677 463.296 513.022 448.493C503.367 433.69 489.643 422.152 473.587 415.339C457.531 408.526 439.863 406.743 422.818 410.216C405.773 413.69 390.116 422.263 377.827 434.852C365.538 447.441 357.169 463.481 353.779 480.943C350.388 498.404 352.129 516.503 358.779 532.952C365.43 549.401 376.692 563.459 391.143 573.351C405.593 583.242 422.582 588.522 439.96 588.522C454.377 588.588 468.584 584.983 481.304 578.029C494.022 571.076 504.855 560.993 512.828 548.688C513.29 547.967 513.887 547.346 514.583 546.862C515.279 546.377 516.063 546.037 516.887 545.863C517.712 545.688 518.561 545.681 519.388 545.844C520.215 546.005 521.003 546.332 521.707 546.806C522.41 547.28 523.016 547.891 523.49 548.604C523.963 549.317 524.294 550.12 524.464 550.964C524.635 551.809 524.641 552.679 524.484 553.527C524.326 554.374 524.006 555.18 523.544 555.902C514.356 569.981 501.923 581.525 487.345 589.512C472.767 597.498 456.492 601.683 439.96 601.695Z"
        fill="#9E8AD9"
      />
      <path
        d="M439.973 574.085C430.285 574.127 420.687 572.177 411.747 568.353C402.806 564.528 394.706 558.905 387.924 551.817C377.626 541.234 370.613 527.766 367.769 513.109C364.925 498.453 366.376 483.262 371.94 469.447C377.504 455.634 386.932 443.815 399.037 435.477C411.143 427.14 425.386 422.657 439.973 422.593C449.661 422.552 459.259 424.501 468.199 428.326C477.139 432.151 485.24 437.774 492.021 444.862C492.604 445.46 493.067 446.169 493.382 446.949C493.698 447.729 493.86 448.566 493.86 449.41C493.86 450.255 493.698 451.091 493.382 451.872C493.067 452.652 492.604 453.361 492.021 453.958C491.438 454.556 490.746 455.029 489.984 455.352C489.222 455.676 488.406 455.842 487.582 455.842C486.757 455.842 485.941 455.676 485.179 455.352C484.418 455.029 483.725 454.555 483.142 453.958C477.483 448.145 470.753 443.542 463.342 440.419C455.93 437.296 447.987 435.714 439.973 435.767C423.813 435.806 408.313 442.338 396.803 453.958C388.247 462.688 382.416 473.825 380.051 485.957C377.685 498.088 378.892 510.666 383.518 522.092C388.144 533.52 395.98 543.281 406.032 550.137C416.083 556.993 427.897 560.634 439.973 560.599C448.975 560.623 457.871 558.605 466.021 554.688C474.172 550.772 481.374 545.055 487.111 537.948C492.848 530.841 496.978 522.521 499.203 513.584C501.429 504.648 501.694 495.318 499.981 486.264C499.819 485.44 499.817 484.591 499.975 483.765C500.134 482.94 500.449 482.156 500.904 481.456C501.359 480.755 501.944 480.154 502.626 479.686C503.308 479.218 504.073 478.891 504.878 478.727C505.683 478.561 506.512 478.561 507.317 478.725C508.122 478.888 508.888 479.213 509.571 479.68C510.254 480.147 510.84 480.747 511.296 481.447C511.751 482.145 512.069 482.93 512.228 483.755C514.568 495.879 513.949 508.407 510.423 520.226C506.898 532.046 500.576 542.79 492.021 551.503C485.298 558.692 477.215 564.402 468.266 568.285C459.318 572.167 449.691 574.141 439.973 574.085Z"
        fill="#9E8AD9"
      />
      <path
        d="M439.966 543.043C431.4 543.08 423.019 540.506 415.886 535.649C408.753 530.792 403.192 523.872 399.91 515.767C396.627 507.664 395.772 498.743 397.453 490.139C399.134 481.536 403.274 473.639 409.349 467.454C410.526 466.247 412.123 465.57 413.788 465.57C415.453 465.57 417.05 466.247 418.227 467.454C419.405 468.659 420.066 470.296 420.066 472.001C420.066 473.707 419.405 475.344 418.227 476.55C413.133 481.876 410.07 488.896 409.596 496.338C409.121 503.779 411.266 511.148 415.641 517.109C420.016 523.069 426.331 527.225 433.441 528.823C440.551 530.422 447.985 529.357 454.395 525.821C460.804 522.286 465.763 516.515 468.374 509.553C470.986 502.592 471.074 494.903 468.626 487.881C466.176 480.858 461.351 474.967 455.026 471.277C448.7 467.587 441.293 466.342 434.149 467.767C432.525 468.097 430.842 467.753 429.466 466.811C428.091 465.87 427.136 464.408 426.811 462.747C426.487 461.085 426.819 459.359 427.736 457.948C428.652 456.537 430.078 455.557 431.699 455.221C437.629 454.018 443.739 454.102 449.635 455.466C455.532 456.829 461.084 459.444 465.934 463.14C470.784 466.836 474.824 471.532 477.795 476.926C480.765 482.319 482.599 488.291 483.18 494.455C483.761 500.619 483.073 506.839 481.164 512.715C479.254 518.59 476.165 523.991 472.093 528.568C468.022 533.146 463.059 536.799 457.525 539.292C451.992 541.785 446.01 543.062 439.966 543.043Z"
        fill="#9E8AD9"
      />
      <path
        d="M803.664 538.227V572.924H769.709V631H732.971V572.924H599.562V548.246L696.047 364.926H737.053L645.578 538.227H732.971V456.215H769.709V538.227H803.664Z"
        fill="#9E8AD9"
      />
      <g filter="url(#filter0_d_2453_565)">
        <path
          d="M437.992 696.515C548.044 696.515 637.15 607.637 637.014 498C636.878 388.363 547.553 299.485 437.501 299.485C327.449 299.485 238.343 388.363 238.479 498C238.614 607.637 327.939 696.515 437.992 696.515Z"
          fill="#F2F0FF"
          fillOpacity="0.13"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#filter1_d_2453_565)">
        <path
          d="M-0.00439453 587.5C-0.00439453 570.931 13.4271 557.5 29.9956 557.5H111.834C128.402 557.5 141.834 570.931 141.834 587.5V619.5H29.9956C13.4271 619.5 -0.00439453 606.069 -0.00439453 589.5V587.5Z"
          fill="url(#paint0_linear_2453_565)"
          fillOpacity="0.6"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#filter2_d_2453_565)">
        <path
          d="M647.257 733.5H755.098C772.219 733.5 786.098 747.379 786.098 764.5C786.098 781.621 772.219 795.5 755.098 795.5H687.257C665.165 795.5 647.257 777.591 647.257 755.5V733.5Z"
          fill="url(#paint1_linear_2453_565)"
          fillOpacity="0.6"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#filter3_d_2453_565)">
        <path
          d="M517.405 221.5C517.405 204.931 530.837 191.5 547.405 191.5H673.193C689.762 191.5 703.193 204.931 703.193 221.5V223.5C703.193 240.069 689.762 253.5 673.193 253.5H517.405V221.5Z"
          fill="url(#paint2_linear_2453_565)"
          fillOpacity="0.6"
          shapeRendering="crispEdges"
        />
      </g>
      <mask id="path-11-inside-1_2453_565" fill="white">
        <path d="M599.43 445.376C601.531 444.694 603.792 445.844 604.425 447.96C611.548 471.754 613.509 496.795 610.177 521.408C609.881 523.597 607.826 525.084 605.644 524.738L542.886 514.773C540.704 514.426 539.224 512.377 539.485 510.184C541.089 496.73 540.021 483.091 536.343 470.051C535.743 467.925 536.886 465.671 538.987 464.989L599.43 445.376Z" />
      </mask>
      <path
        d="M599.43 445.376C601.531 444.694 603.792 445.844 604.425 447.96C611.548 471.754 613.509 496.795 610.177 521.408C609.881 523.597 607.826 525.084 605.644 524.738L542.886 514.773C540.704 514.426 539.224 512.377 539.485 510.184C541.089 496.73 540.021 483.091 536.343 470.051C535.743 467.925 536.886 465.671 538.987 464.989L599.43 445.376Z"
        fill="#6A52B7"
        stroke="#483389"
        strokeWidth="2"
        mask="url(#path-11-inside-1_2453_565)"
      />
      <mask id="path-12-inside-2_2453_565" fill="white">
        <path d="M605.696 524.41C607.879 524.752 609.375 526.8 608.983 528.974C604.575 553.416 594.999 576.637 580.896 597.082C579.642 598.9 577.137 599.298 575.347 598.002L523.88 560.732C522.091 559.436 521.698 556.939 522.923 555.101C530.438 543.827 535.653 531.18 538.27 517.886C538.697 515.719 540.736 514.225 542.918 514.567L605.696 524.41Z" />
      </mask>
      <path
        d="M605.696 524.41C607.879 524.752 609.375 526.8 608.983 528.974C604.575 553.416 594.999 576.637 580.896 597.082C579.642 598.9 577.137 599.298 575.347 598.002L523.88 560.732C522.091 559.436 521.698 556.939 522.923 555.101C530.438 543.827 535.653 531.18 538.27 517.886C538.697 515.719 540.736 514.225 542.918 514.567L605.696 524.41Z"
        fill="#6A52B7"
        stroke="#483389"
        strokeWidth="2"
        mask="url(#path-12-inside-2_2453_565)"
      />
      <mask id="path-13-inside-3_2453_565" fill="white">
        <path d="M575.32 598.041C577.108 599.337 577.511 601.841 576.175 603.6C561.144 623.373 542.066 639.71 520.215 651.518C518.272 652.568 515.859 651.784 514.854 649.817L485.933 593.235C484.927 591.268 485.711 588.865 487.638 587.784C499.453 581.154 509.844 572.256 518.214 561.602C519.579 559.864 522.074 559.46 523.863 560.756L575.32 598.041Z" />
      </mask>
      <path
        d="M575.32 598.041C577.108 599.337 577.511 601.841 576.175 603.6C561.144 623.373 542.066 639.71 520.215 651.518C518.272 652.568 515.859 651.784 514.854 649.817L485.933 593.235C484.927 591.268 485.711 588.865 487.638 587.784C499.453 581.154 509.844 572.256 518.214 561.602C519.579 559.864 522.074 559.46 523.863 560.756L575.32 598.041Z"
        fill="#6A52B7"
        stroke="#483389"
        strokeWidth="2"
        mask="url(#path-13-inside-3_2453_565)"
      />
      <mask id="path-14-inside-4_2453_565" fill="white">
        <path d="M515.393 649.54C516.406 651.504 515.637 653.921 513.65 654.888C491.32 665.762 466.925 671.743 442.098 672.433C439.889 672.494 438.089 670.707 438.079 668.498L437.771 604.954C437.761 602.745 439.544 600.953 441.751 600.857C455.287 600.265 468.573 597.007 480.848 591.27C482.849 590.335 485.258 591.098 486.271 593.062L515.393 649.54Z" />
      </mask>
      <path
        d="M515.393 649.54C516.406 651.504 515.637 653.921 513.65 654.888C491.32 665.762 466.925 671.743 442.098 672.433C439.889 672.494 438.089 670.707 438.079 668.498L437.771 604.954C437.761 602.745 439.544 600.953 441.751 600.857C455.287 600.265 468.573 597.007 480.848 591.27C482.849 590.335 485.258 591.098 486.271 593.062L515.393 649.54Z"
        fill="#6A52B7"
        stroke="#483389"
        strokeWidth="2"
        mask="url(#path-14-inside-4_2453_565)"
      />
      <path
        d="M531.221 381.357C530.462 382.379 529.497 382.973 528.326 383.141C527.153 383.305 526.079 383.025 525.103 382.301C524.128 381.576 523.552 380.63 523.374 379.461C523.196 378.292 523.486 377.197 524.246 376.175C524.709 375.551 525.282 375.091 525.965 374.795C526.649 374.495 527.35 374.393 528.068 374.488L527.972 375.344C527.403 375.252 526.841 375.324 526.287 375.56C525.732 375.795 525.27 376.162 524.9 376.66C524.275 377.501 524.037 378.392 524.184 379.333C524.334 380.272 524.807 381.037 525.603 381.628C526.4 382.22 527.269 382.452 528.21 382.324C529.152 382.197 529.936 381.711 530.563 380.867C530.935 380.366 531.156 379.817 531.224 379.22C531.29 378.621 531.195 378.065 530.94 377.549L531.718 377.2C532.021 377.853 532.13 378.555 532.045 379.304C531.959 380.049 531.685 380.733 531.221 381.357ZM535.118 375.865L526.92 372.811L527.451 372.096L534.516 374.76L529.991 368.677L530.578 367.886L537.709 370.461L533.119 364.467L533.65 363.752L538.941 370.719L538.34 371.528L531.174 368.942L535.719 375.056L535.118 375.865ZM541.046 366.56L543.481 363.282L544.116 363.753L541.181 367.704L534.436 362.694L537.333 358.795L537.972 359.27L535.575 362.496L537.96 364.268L540.179 361.281L540.819 361.756L538.6 364.743L541.046 366.56ZM542.309 360.615L541.693 360.157L544.268 356.691L544.884 357.149L542.309 360.615ZM542.808 351.424L543.234 350.85L549.979 355.861L549.48 356.534L543.478 352.075L542.808 353.92L542.1 353.665L542.808 351.424ZM550.839 354.704L550.232 354.253L549.589 350.009C549.411 348.801 549.074 348.014 548.579 347.645C548.149 347.326 547.715 347.21 547.275 347.297C546.836 347.385 546.478 347.615 546.2 347.988C545.686 348.681 545.63 349.421 546.034 350.207L545.272 350.525C545.013 350.002 544.913 349.479 544.97 348.957C545.026 348.429 545.218 347.944 545.547 347.502C545.947 346.963 546.481 346.625 547.147 346.487C547.813 346.344 548.458 346.505 549.082 346.968C549.474 347.259 549.769 347.649 549.966 348.136C550.161 348.621 550.309 349.211 550.412 349.905L550.901 353.254L553.368 349.933L554.022 350.419L550.839 354.704ZM556.153 343.404L556.788 343.876L556.142 344.746L557.492 345.749L556.992 346.421L555.642 345.418L552.994 348.984L552.359 348.512L549.461 342.469L550.01 341.73L552.911 347.769L555.007 344.947L552.947 343.416L553.447 342.744L555.507 344.274L556.153 343.404Z"
        fill="#FBFDFF"
      />
      <path
        d="M437.496 398.5C437.496 396.291 439.288 394.492 441.495 394.577C461.917 395.369 481.68 402.205 498.262 414.267C514.846 426.33 527.449 443.037 534.511 462.239C535.273 464.312 534.117 466.57 532.017 467.253L499.312 477.892C497.211 478.575 494.965 477.419 494.147 475.366C489.888 464.681 482.688 455.391 473.348 448.597C464.009 441.804 452.959 437.82 441.493 437.066C439.289 436.921 437.496 435.144 437.496 432.935L437.496 398.5Z"
        fill="#9E8AD9"
        stroke="#483389"
      />
      <mask id="path-17-inside-5_2453_565" fill="white">
        <path d="M531.973 467.136C534.074 466.449 536.341 467.595 536.944 469.721C541.029 484.118 541.95 499.246 539.625 514.062C537.094 530.197 530.783 545.504 521.21 558.73C511.637 571.956 499.074 582.726 484.547 590.16C471.208 596.985 456.562 600.82 441.625 601.417C439.418 601.506 437.624 599.709 437.621 597.5L437.578 563.065C437.575 560.856 439.366 559.076 441.57 558.929C449.814 558.376 457.874 556.151 465.256 552.374C473.827 547.988 481.239 541.634 486.887 533.831C492.535 526.027 496.259 516.997 497.752 507.477C499.039 499.275 498.64 490.912 496.596 482.895C496.05 480.755 497.183 478.501 499.282 477.815L531.973 467.136Z" />
      </mask>
      <path
        d="M531.973 467.136C534.074 466.449 536.341 467.595 536.944 469.721C541.029 484.118 541.95 499.246 539.625 514.062C537.094 530.197 530.783 545.504 521.21 558.73C511.637 571.956 499.074 582.726 484.547 590.16C471.208 596.985 456.562 600.82 441.625 601.417C439.418 601.506 437.624 599.709 437.621 597.5L437.578 563.065C437.575 560.856 439.366 559.076 441.57 558.929C449.814 558.376 457.874 556.151 465.256 552.374C473.827 547.988 481.239 541.634 486.887 533.831C492.535 526.027 496.259 516.997 497.752 507.477C499.039 499.275 498.64 490.912 496.596 482.895C496.05 480.755 497.183 478.501 499.282 477.815L531.973 467.136Z"
        fill="#9E8AD9"
        stroke="#483389"
        strokeWidth="2"
        mask="url(#path-17-inside-5_2453_565)"
      />
      <mask
        id="mask0_2453_565"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="245"
        y="152"
        width="602"
        height="4"
      >
        <circle cx="845.029" cy="154.24" r="1.5" transform="rotate(-180 845.029 154.24)" fill="#F24C84" />
        <circle cx="836.944" cy="154.24" r="1.5" transform="rotate(-180 836.944 154.24)" fill="#F24C84" />
        <circle cx="828.858" cy="154.24" r="1.5" transform="rotate(-180 828.858 154.24)" fill="#F24C84" />
        <circle cx="820.773" cy="154.24" r="1.5" transform="rotate(-180 820.773 154.24)" fill="#F24C84" />
        <circle cx="812.688" cy="154.24" r="1.5" transform="rotate(-180 812.688 154.24)" fill="#F24C84" />
        <circle cx="804.603" cy="154.24" r="1.5" transform="rotate(-180 804.603 154.24)" fill="#F24C84" />
        <circle cx="796.518" cy="154.24" r="1.5" transform="rotate(-180 796.518 154.24)" fill="#F24C84" />
        <circle cx="788.432" cy="154.24" r="1.5" transform="rotate(-180 788.432 154.24)" fill="#F24C84" />
        <circle cx="780.347" cy="154.24" r="1.5" transform="rotate(-180 780.347 154.24)" fill="#F24C84" />
        <circle cx="772.262" cy="154.24" r="1.5" transform="rotate(-180 772.262 154.24)" fill="#F24C84" />
        <circle cx="764.176" cy="154.24" r="1.5" transform="rotate(-180 764.176 154.24)" fill="#F24C84" />
        <circle cx="756.091" cy="154.24" r="1.5" transform="rotate(-180 756.091 154.24)" fill="#F24C84" />
        <circle cx="748.006" cy="154.24" r="1.5" transform="rotate(-180 748.006 154.24)" fill="#F24C84" />
        <circle cx="739.92" cy="154.24" r="1.5" transform="rotate(-180 739.92 154.24)" fill="#F24C84" />
        <circle cx="731.835" cy="154.24" r="1.5" transform="rotate(-180 731.835 154.24)" fill="#F24C84" />
        <circle cx="723.749" cy="154.24" r="1.5" transform="rotate(-180 723.749 154.24)" fill="#F24C84" />
        <circle cx="715.664" cy="154.24" r="1.5" transform="rotate(-180 715.664 154.24)" fill="#F24C84" />
        <circle cx="707.579" cy="154.24" r="1.5" transform="rotate(-180 707.579 154.24)" fill="#F24C84" />
        <circle cx="699.493" cy="154.24" r="1.5" transform="rotate(-180 699.493 154.24)" fill="#F24C84" />
        <circle cx="691.408" cy="154.24" r="1.5" transform="rotate(-180 691.408 154.24)" fill="#F24C84" />
        <circle cx="683.323" cy="154.24" r="1.5" transform="rotate(-180 683.323 154.24)" fill="#F24C84" />
        <circle cx="675.237" cy="154.24" r="1.5" transform="rotate(-180 675.237 154.24)" fill="#F24C84" />
        <circle cx="667.152" cy="154.24" r="1.5" transform="rotate(-180 667.152 154.24)" fill="#F24C84" />
        <circle cx="659.066" cy="154.24" r="1.5" transform="rotate(-180 659.066 154.24)" fill="#F24C84" />
        <circle cx="650.981" cy="154.24" r="1.5" transform="rotate(-180 650.981 154.24)" fill="#F24C84" />
        <circle cx="642.896" cy="154.24" r="1.5" transform="rotate(-180 642.896 154.24)" fill="#F24C84" />
        <circle cx="634.811" cy="154.24" r="1.5" transform="rotate(-180 634.811 154.24)" fill="#F24C84" />
        <circle cx="626.726" cy="154.24" r="1.5" transform="rotate(-180 626.726 154.24)" fill="#F24C84" />
        <circle cx="618.641" cy="154.24" r="1.5" transform="rotate(-180 618.641 154.24)" fill="#F24C84" />
        <circle cx="610.555" cy="154.24" r="1.5" transform="rotate(-180 610.555 154.24)" fill="#F24C84" />
        <circle cx="602.47" cy="154.24" r="1.5" transform="rotate(-180 602.47 154.24)" fill="#F24C84" />
        <circle cx="594.384" cy="154.24" r="1.5" transform="rotate(-180 594.384 154.24)" fill="#F24C84" />
        <circle cx="586.299" cy="154.24" r="1.5" transform="rotate(-180 586.299 154.24)" fill="#F24C84" />
        <circle cx="578.214" cy="154.24" r="1.5" transform="rotate(-180 578.214 154.24)" fill="#F24C84" />
        <circle cx="570.128" cy="154.24" r="1.5" transform="rotate(-180 570.128 154.24)" fill="#F24C84" />
        <circle cx="562.043" cy="154.24" r="1.5" transform="rotate(-180 562.043 154.24)" fill="#F24C84" />
        <circle cx="553.958" cy="154.24" r="1.5" transform="rotate(-180 553.958 154.24)" fill="#F24C84" />
        <circle cx="545.872" cy="154.24" r="1.5" transform="rotate(-180 545.872 154.24)" fill="#F24C84" />
        <circle cx="537.787" cy="154.24" r="1.5" transform="rotate(-180 537.787 154.24)" fill="#F24C84" />
        <circle cx="529.701" cy="154.24" r="1.5" transform="rotate(-180 529.701 154.24)" fill="#F24C84" />
        <circle cx="521.616" cy="154.24" r="1.5" transform="rotate(-180 521.616 154.24)" fill="#F24C84" />
        <circle cx="513.531" cy="154.24" r="1.5" transform="rotate(-180 513.531 154.24)" fill="#F24C84" />
        <circle cx="505.445" cy="154.24" r="1.5" transform="rotate(-180 505.445 154.24)" fill="#F24C84" />
        <circle cx="497.36" cy="154.24" r="1.5" transform="rotate(-180 497.36 154.24)" fill="#F24C84" />
        <circle cx="489.275" cy="154.24" r="1.5" transform="rotate(-180 489.275 154.24)" fill="#F24C84" />
        <circle cx="481.189" cy="154.24" r="1.5" transform="rotate(-180 481.189 154.24)" fill="#F24C84" />
        <circle cx="473.104" cy="154.24" r="1.5" transform="rotate(-180 473.104 154.24)" fill="#F24C84" />
        <circle cx="465.019" cy="154.24" r="1.5" transform="rotate(-180 465.019 154.24)" fill="#F24C84" />
        <circle cx="456.934" cy="154.24" r="1.5" transform="rotate(-180 456.934 154.24)" fill="#F24C84" />
        <circle cx="448.849" cy="154.24" r="1.5" transform="rotate(-180 448.849 154.24)" fill="#F24C84" />
        <circle cx="440.763" cy="154.24" r="1.5" transform="rotate(-180 440.763 154.24)" fill="#F24C84" />
        <circle cx="432.678" cy="154.24" r="1.5" transform="rotate(-180 432.678 154.24)" fill="#F24C84" />
        <circle cx="424.593" cy="154.24" r="1.5" transform="rotate(-180 424.593 154.24)" fill="#F24C84" />
        <circle cx="416.507" cy="154.24" r="1.5" transform="rotate(-180 416.507 154.24)" fill="#F24C84" />
        <circle cx="408.422" cy="154.24" r="1.5" transform="rotate(-180 408.422 154.24)" fill="#F24C84" />
        <circle cx="400.336" cy="154.24" r="1.5" transform="rotate(-180 400.336 154.24)" fill="#F24C84" />
        <circle cx="392.251" cy="154.24" r="1.5" transform="rotate(-180 392.251 154.24)" fill="#F24C84" />
        <circle cx="384.166" cy="154.24" r="1.5" transform="rotate(-180 384.166 154.24)" fill="#F24C84" />
        <circle cx="376.08" cy="154.24" r="1.5" transform="rotate(-180 376.08 154.24)" fill="#F24C84" />
        <circle cx="367.995" cy="154.24" r="1.5" transform="rotate(-180 367.995 154.24)" fill="#F24C84" />
        <circle cx="359.91" cy="154.24" r="1.5" transform="rotate(-180 359.91 154.24)" fill="#F24C84" />
        <circle cx="351.824" cy="154.24" r="1.5" transform="rotate(-180 351.824 154.24)" fill="#F24C84" />
        <circle cx="343.739" cy="154.24" r="1.5" transform="rotate(-180 343.739 154.24)" fill="#F24C84" />
        <circle cx="335.653" cy="154.24" r="1.5" transform="rotate(-180 335.653 154.24)" fill="#F24C84" />
        <circle cx="327.568" cy="154.24" r="1.5" transform="rotate(-180 327.568 154.24)" fill="#F24C84" />
        <circle cx="319.483" cy="154.24" r="1.5" transform="rotate(-180 319.483 154.24)" fill="#F24C84" />
        <circle cx="311.397" cy="154.24" r="1.5" transform="rotate(-180 311.397 154.24)" fill="#F04586" />
        <circle cx="303.312" cy="154.24" r="1.5" transform="rotate(-180 303.312 154.24)" fill="#F04586" />
        <circle cx="295.228" cy="154.24" r="1.5" transform="rotate(-180 295.228 154.24)" fill="#F04586" />
        <circle cx="287.142" cy="154.24" r="1.5" transform="rotate(-180 287.142 154.24)" fill="#F04586" />
        <circle cx="279.057" cy="154.24" r="1.5" transform="rotate(-180 279.057 154.24)" fill="#F04586" />
        <circle cx="270.971" cy="154.24" r="1.5" transform="rotate(-180 270.971 154.24)" fill="#F04586" />
        <circle cx="262.886" cy="154.24" r="1.5" transform="rotate(-180 262.886 154.24)" fill="#F04586" />
        <circle cx="254.8" cy="154.24" r="1.5" transform="rotate(-180 254.8 154.24)" fill="#F04586" />
        <circle cx="246.715" cy="154.24" r="1.5" transform="rotate(-180 246.715 154.24)" fill="#F04586" />
      </mask>
      <g mask="url(#mask0_2453_565)">
        <rect
          x="871.977"
          y="117.315"
          width="105.384"
          height="627.703"
          transform="rotate(90 871.977 117.315)"
          fill="url(#paint3_linear_2453_565)"
        />
      </g>
      <mask
        id="mask1_2453_565"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="695"
        y="351"
        width="4"
        height="726"
      >
        <circle cx="697.499" cy="353.019" r="1.5" transform="rotate(90 697.499 353.019)" fill="#F24C84" />
        <circle cx="697.499" cy="362.782" r="1.5" transform="rotate(90 697.499 362.782)" fill="#F24C84" />
        <circle cx="697.499" cy="372.545" r="1.5" transform="rotate(90 697.499 372.545)" fill="#F24C84" />
        <circle cx="697.499" cy="382.309" r="1.5" transform="rotate(90 697.499 382.309)" fill="#F24C84" />
        <circle cx="697.499" cy="392.071" r="1.5" transform="rotate(90 697.499 392.071)" fill="#F24C84" />
        <circle cx="697.499" cy="401.835" r="1.5" transform="rotate(90 697.499 401.835)" fill="#F24C84" />
        <circle cx="697.499" cy="411.598" r="1.5" transform="rotate(90 697.499 411.598)" fill="#F24C84" />
        <circle cx="697.499" cy="421.361" r="1.5" transform="rotate(90 697.499 421.361)" fill="#F24C84" />
        <circle cx="697.499" cy="431.125" r="1.5" transform="rotate(90 697.499 431.125)" fill="#F24C84" />
        <circle cx="697.499" cy="440.888" r="1.5" transform="rotate(90 697.499 440.888)" fill="#F24C84" />
        <circle cx="697.499" cy="450.651" r="1.5" transform="rotate(90 697.499 450.651)" fill="#F24C84" />
        <circle cx="697.499" cy="460.414" r="1.5" transform="rotate(90 697.499 460.414)" fill="#F24C84" />
        <circle cx="697.499" cy="470.178" r="1.5" transform="rotate(90 697.499 470.178)" fill="#F24C84" />
        <circle cx="697.499" cy="479.941" r="1.5" transform="rotate(90 697.499 479.941)" fill="#F24C84" />
        <circle cx="697.499" cy="489.704" r="1.5" transform="rotate(90 697.499 489.704)" fill="#F24C84" />
        <circle cx="697.499" cy="499.468" r="1.5" transform="rotate(90 697.499 499.468)" fill="#F24C84" />
        <circle cx="697.499" cy="509.23" r="1.5" transform="rotate(90 697.499 509.23)" fill="#F24C84" />
        <circle cx="697.499" cy="518.994" r="1.5" transform="rotate(90 697.499 518.994)" fill="#F24C84" />
        <circle cx="697.499" cy="528.757" r="1.5" transform="rotate(90 697.499 528.757)" fill="#F24C84" />
        <circle cx="697.499" cy="538.521" r="1.5" transform="rotate(90 697.499 538.521)" fill="#F24C84" />
        <circle cx="697.499" cy="548.284" r="1.5" transform="rotate(90 697.499 548.284)" fill="#F24C84" />
        <circle cx="697.499" cy="558.047" r="1.5" transform="rotate(90 697.499 558.047)" fill="#F24C84" />
        <circle cx="697.499" cy="567.811" r="1.5" transform="rotate(90 697.499 567.811)" fill="#F24C84" />
        <circle cx="697.499" cy="577.573" r="1.5" transform="rotate(90 697.499 577.573)" fill="#F24C84" />
        <circle cx="697.499" cy="587.337" r="1.5" transform="rotate(90 697.499 587.337)" fill="#F24C84" />
        <circle cx="697.499" cy="597.1" r="1.5" transform="rotate(90 697.499 597.1)" fill="#F24C84" />
        <circle cx="697.499" cy="606.863" r="1.5" transform="rotate(90 697.499 606.863)" fill="#F24C84" />
        <circle cx="697.499" cy="616.627" r="1.5" transform="rotate(90 697.499 616.627)" fill="#F24C84" />
        <circle cx="697.499" cy="626.39" r="1.5" transform="rotate(90 697.499 626.39)" fill="#F24C84" />
        <circle cx="697.499" cy="636.153" r="1.5" transform="rotate(90 697.499 636.153)" fill="#F24C84" />
        <circle cx="697.499" cy="645.916" r="1.5" transform="rotate(90 697.499 645.916)" fill="#F24C84" />
        <circle cx="697.499" cy="655.68" r="1.5" transform="rotate(90 697.499 655.68)" fill="#F24C84" />
        <circle cx="697.499" cy="665.442" r="1.5" transform="rotate(90 697.499 665.442)" fill="#F24C84" />
        <circle cx="697.499" cy="675.206" r="1.5" transform="rotate(90 697.499 675.206)" fill="#F24C84" />
        <circle cx="697.499" cy="684.97" r="1.5" transform="rotate(90 697.499 684.97)" fill="#F24C84" />
        <circle cx="697.499" cy="694.732" r="1.5" transform="rotate(90 697.499 694.732)" fill="#F24C84" />
        <circle cx="697.499" cy="704.496" r="1.5" transform="rotate(90 697.499 704.496)" fill="#F24C84" />
        <circle cx="697.499" cy="714.259" r="1.5" transform="rotate(90 697.499 714.259)" fill="#F24C84" />
        <circle cx="697.499" cy="724.022" r="1.5" transform="rotate(90 697.499 724.022)" fill="#F24C84" />
        <circle cx="697.499" cy="733.785" r="1.5" transform="rotate(90 697.499 733.785)" fill="#F24C84" />
        <circle cx="697.499" cy="743.549" r="1.5" transform="rotate(90 697.499 743.549)" fill="#F24C84" />
        <circle cx="697.499" cy="753.312" r="1.5" transform="rotate(90 697.499 753.312)" fill="#F24C84" />
        <circle cx="697.499" cy="763.075" r="1.5" transform="rotate(90 697.499 763.075)" fill="#F24C84" />
        <circle cx="697.499" cy="772.839" r="1.5" transform="rotate(90 697.499 772.839)" fill="#F24C84" />
        <circle cx="697.499" cy="782.602" r="1.5" transform="rotate(90 697.499 782.602)" fill="#F24C84" />
        <circle cx="697.499" cy="792.365" r="1.5" transform="rotate(90 697.499 792.365)" fill="#F24C84" />
        <circle cx="697.499" cy="802.128" r="1.5" transform="rotate(90 697.499 802.128)" fill="#F24C84" />
        <circle cx="697.499" cy="811.892" r="1.5" transform="rotate(90 697.499 811.892)" fill="#F24C84" />
        <circle cx="697.499" cy="821.654" r="1.5" transform="rotate(90 697.499 821.654)" fill="#F24C84" />
        <circle cx="697.499" cy="831.418" r="1.5" transform="rotate(90 697.499 831.418)" fill="#F24C84" />
        <circle cx="697.499" cy="841.182" r="1.5" transform="rotate(90 697.499 841.182)" fill="#F24C84" />
        <circle cx="697.499" cy="850.944" r="1.5" transform="rotate(90 697.499 850.944)" fill="#F24C84" />
        <circle cx="697.499" cy="860.708" r="1.5" transform="rotate(90 697.499 860.708)" fill="#F24C84" />
        <circle cx="697.499" cy="870.471" r="1.5" transform="rotate(90 697.499 870.471)" fill="#F24C84" />
        <circle cx="697.499" cy="880.234" r="1.5" transform="rotate(90 697.499 880.234)" fill="#F24C84" />
        <circle cx="697.499" cy="889.997" r="1.5" transform="rotate(90 697.499 889.997)" fill="#F24C84" />
        <circle cx="697.499" cy="899.761" r="1.5" transform="rotate(90 697.499 899.761)" fill="#F24C84" />
        <circle cx="697.499" cy="909.523" r="1.5" transform="rotate(90 697.499 909.523)" fill="#F24C84" />
        <circle cx="697.499" cy="919.287" r="1.5" transform="rotate(90 697.499 919.287)" fill="#F24C84" />
        <circle cx="697.499" cy="929.051" r="1.5" transform="rotate(90 697.499 929.051)" fill="#F24C84" />
        <circle cx="697.499" cy="938.813" r="1.5" transform="rotate(90 697.499 938.813)" fill="#F24C84" />
        <circle cx="697.499" cy="948.577" r="1.5" transform="rotate(90 697.499 948.577)" fill="#F24C84" />
        <circle cx="697.499" cy="958.34" r="1.5" transform="rotate(90 697.499 958.34)" fill="#F24C84" />
        <circle cx="697.499" cy="968.104" r="1.5" transform="rotate(90 697.499 968.104)" fill="#F24C84" />
        <circle cx="697.499" cy="977.866" r="1.5" transform="rotate(90 697.499 977.866)" fill="#F24C84" />
        <circle cx="697.499" cy="987.63" r="1.5" transform="rotate(90 697.499 987.63)" fill="#F24C84" />
        <circle cx="697.499" cy="997.394" r="1.5" transform="rotate(90 697.499 997.394)" fill="#F04586" />
        <circle cx="697.499" cy="1007.16" r="1.5" transform="rotate(90 697.499 1007.16)" fill="#F04586" />
        <circle cx="697.499" cy="1016.92" r="1.5" transform="rotate(90 697.499 1016.92)" fill="#F04586" />
        <circle cx="697.499" cy="1026.68" r="1.5" transform="rotate(90 697.499 1026.68)" fill="#F04586" />
        <circle cx="697.499" cy="1036.45" r="1.5" transform="rotate(90 697.499 1036.45)" fill="#F04586" />
        <circle cx="697.499" cy="1046.21" r="1.5" transform="rotate(90 697.499 1046.21)" fill="#F04586" />
        <circle cx="697.499" cy="1055.97" r="1.5" transform="rotate(90 697.499 1055.97)" fill="#F04586" />
        <circle cx="697.499" cy="1065.74" r="1.5" transform="rotate(90 697.499 1065.74)" fill="#F04586" />
        <circle cx="697.499" cy="1075.5" r="1.5" transform="rotate(90 697.499 1075.5)" fill="#F04586" />
      </mask>
      <g mask="url(#mask1_2453_565)">
        <rect x="653.05" y="420.816" width="126.855" height="757.32" fill="url(#paint4_linear_2453_565)" />
      </g>
      <mask
        id="mask2_2453_565"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="770"
        y="-335"
        width="4"
        height="726"
      >
        <circle cx="772.413" cy="8.21387" r="1.5" transform="rotate(90 772.413 8.21387)" fill="#F24C84" />
        <circle cx="772.413" cy="17.9775" r="1.5" transform="rotate(90 772.413 17.9775)" fill="#F24C84" />
        <circle cx="772.413" cy="27.7402" r="1.5" transform="rotate(90 772.413 27.7402)" fill="#F24C84" />
        <circle cx="772.413" cy="37.5039" r="1.5" transform="rotate(90 772.413 37.5039)" fill="#F24C84" />
        <circle cx="772.413" cy="47.2666" r="1.5" transform="rotate(90 772.413 47.2666)" fill="#F24C84" />
        <circle cx="772.413" cy="57.0303" r="1.5" transform="rotate(90 772.413 57.0303)" fill="#F24C84" />
        <circle cx="772.413" cy="66.793" r="1.5" transform="rotate(90 772.413 66.793)" fill="#F24C84" />
        <circle cx="772.413" cy="76.5566" r="1.5" transform="rotate(90 772.413 76.5566)" fill="#F24C84" />
        <circle cx="772.413" cy="86.3203" r="1.5" transform="rotate(90 772.413 86.3203)" fill="#F24C84" />
        <circle cx="772.413" cy="96.083" r="1.5" transform="rotate(90 772.413 96.083)" fill="#F24C84" />
        <circle cx="772.413" cy="105.847" r="1.5" transform="rotate(90 772.413 105.847)" fill="#F24C84" />
        <circle cx="772.413" cy="115.609" r="1.5" transform="rotate(90 772.413 115.609)" fill="#F24C84" />
        <circle cx="772.413" cy="125.373" r="1.5" transform="rotate(90 772.413 125.373)" fill="#F24C84" />
        <circle cx="772.413" cy="135.136" r="1.5" transform="rotate(90 772.413 135.136)" fill="#F24C84" />
        <circle cx="772.413" cy="144.899" r="1.5" transform="rotate(90 772.413 144.899)" fill="#F24C84" />
        <circle cx="772.413" cy="154.663" r="1.5" transform="rotate(90 772.413 154.663)" fill="#F24C84" />
        <circle cx="772.413" cy="164.426" r="1.5" transform="rotate(90 772.413 164.426)" fill="#F24C84" />
        <circle cx="772.413" cy="174.189" r="1.5" transform="rotate(90 772.413 174.189)" fill="#F24C84" />
        <circle cx="772.413" cy="183.952" r="1.5" transform="rotate(90 772.413 183.952)" fill="#F24C84" />
        <circle cx="772.413" cy="193.716" r="1.5" transform="rotate(90 772.413 193.716)" fill="#F24C84" />
        <circle cx="772.413" cy="203.479" r="1.5" transform="rotate(90 772.413 203.479)" fill="#F24C84" />
        <circle cx="772.413" cy="213.242" r="1.5" transform="rotate(90 772.413 213.242)" fill="#F24C84" />
        <circle cx="772.413" cy="223.006" r="1.5" transform="rotate(90 772.413 223.006)" fill="#F24C84" />
        <circle cx="772.413" cy="232.769" r="1.5" transform="rotate(90 772.413 232.769)" fill="#F24C84" />
        <circle cx="772.413" cy="242.532" r="1.5" transform="rotate(90 772.413 242.532)" fill="#F24C84" />
        <circle cx="772.413" cy="252.295" r="1.5" transform="rotate(90 772.413 252.295)" fill="#F24C84" />
        <circle cx="772.413" cy="262.059" r="1.5" transform="rotate(90 772.413 262.059)" fill="#F24C84" />
        <circle cx="772.413" cy="271.821" r="1.5" transform="rotate(90 772.413 271.821)" fill="#F24C84" />
        <circle cx="772.413" cy="281.585" r="1.5" transform="rotate(90 772.413 281.585)" fill="#F24C84" />
        <circle cx="772.413" cy="291.348" r="1.5" transform="rotate(90 772.413 291.348)" fill="#F24C84" />
        <circle cx="772.413" cy="301.111" r="1.5" transform="rotate(90 772.413 301.111)" fill="#F24C84" />
        <circle cx="772.413" cy="310.875" r="1.5" transform="rotate(90 772.413 310.875)" fill="#F04586" />
        <circle cx="772.413" cy="320.638" r="1.5" transform="rotate(90 772.413 320.638)" fill="#F04586" />
        <circle cx="772.413" cy="330.401" r="1.5" transform="rotate(90 772.413 330.401)" fill="#F04586" />
        <circle cx="772.413" cy="340.164" r="1.5" transform="rotate(90 772.413 340.164)" fill="#F04586" />
        <circle cx="772.413" cy="349.928" r="1.5" transform="rotate(90 772.413 349.928)" fill="#F04586" />
        <circle cx="772.413" cy="359.69" r="1.5" transform="rotate(90 772.413 359.69)" fill="#F04586" />
        <circle cx="772.413" cy="369.454" r="1.5" transform="rotate(90 772.413 369.454)" fill="#F04586" />
        <circle cx="772.413" cy="379.217" r="1.5" transform="rotate(90 772.413 379.217)" fill="#F04586" />
        <circle cx="772.413" cy="388.98" r="1.5" transform="rotate(90 772.413 388.98)" fill="#F04586" />
      </mask>
      <g mask="url(#mask2_2453_565)">
        <rect x="727.964" y="-365.702" width="126.855" height="757.32" fill="url(#paint5_linear_2453_565)" />
      </g>
      <path
        d="M225.238 324.902V289.335V289.335C225.238 288.874 225.612 288.5 226.073 288.5H260.809"
        stroke="url(#paint6_linear_2453_565)"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M608.706 288.5H644.277V288.5C644.738 288.5 645.111 288.874 645.111 289.335V324.067"
        stroke="url(#paint7_linear_2453_565)"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M645.111 671.98V707.547V707.547C645.111 708.009 644.738 708.382 644.277 708.382H609.541"
        stroke="url(#paint8_linear_2453_565)"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M261.644 708.382H226.073V708.382C225.612 708.382 225.238 708.009 225.238 707.547V672.815"
        stroke="url(#paint9_linear_2453_565)"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path d="M437.996 253.5L437.996 213.5" stroke="#CC44D8" strokeWidth="1.5" strokeMiterlimit="10" />
      <path d="M437.862 745.538V785.538" stroke="#CC44D8" strokeWidth="1.5" strokeMiterlimit="10" />
      <path d="M684.714 498.5L754.634 498.5" stroke="#CC44D8" strokeWidth="1.5" strokeMiterlimit="10" />
      <path d="M191.277 499.123H121.357" stroke="#CC44D8" strokeWidth="1.5" strokeMiterlimit="10" />
      <g filter="url(#filter4_d_2453_565)">
        <path
          d="M657.262 569.298C656.257 569.756 655.068 569.314 654.651 568.291C651.196 559.805 650.143 550.516 651.628 541.447C653.221 531.72 657.662 522.685 664.39 515.487C671.118 508.29 679.828 503.254 689.418 501.018C699.007 498.782 709.044 499.447 718.255 502.928C727.467 506.409 735.439 512.55 741.161 520.572C746.883 528.594 750.097 538.136 750.396 547.989C750.695 557.842 748.065 567.562 742.84 575.917C737.969 583.705 731.047 589.981 722.854 594.064C721.865 594.557 720.68 594.103 720.229 593.095L711.736 574.141C711.284 573.132 711.74 571.955 712.708 571.423C716.439 569.375 719.595 566.399 721.865 562.77C724.49 558.573 725.811 553.69 725.661 548.741C725.51 543.792 723.896 538.999 721.022 534.969C718.148 530.94 714.143 527.855 709.516 526.106C704.889 524.358 699.847 524.024 695.031 525.147C690.214 526.27 685.838 528.8 682.459 532.415C679.079 536.03 676.848 540.569 676.048 545.455C675.356 549.681 675.762 554.003 677.21 558.01C677.586 559.049 677.15 560.233 676.145 560.691L657.262 569.298Z"
          fill="url(#paint10_linear_2453_565)"
          fillOpacity="0.6"
        />
        <path
          d="M718.229 593.938C718.635 594.965 718.132 596.132 717.089 596.497C707.254 599.935 696.586 600.194 686.596 597.237C685.538 596.923 684.98 595.783 685.335 594.737L692.05 574.961C692.406 573.915 693.541 573.363 694.611 573.633C699.001 574.743 703.612 574.631 707.943 573.309C708.999 572.987 710.158 573.482 710.564 574.51L718.229 593.938Z"
          fill="url(#paint11_linear_2453_565)"
          fillOpacity="0.6"
        />
        <path
          d="M683.424 594.039C683.025 595.07 681.863 595.585 680.851 595.143C670.822 590.773 662.51 583.212 657.207 573.635C656.672 572.668 657.074 571.463 658.06 570.966L676.699 561.582C677.685 561.085 678.88 561.488 679.453 562.432C681.94 566.527 685.557 569.818 689.867 571.905C690.86 572.386 691.374 573.538 690.975 574.567L683.424 594.039Z"
          fill="url(#paint12_linear_2453_565)"
          fillOpacity="0.6"
        />
      </g>
      <rect
        x="234.979"
        y="297.25"
        width="32.4612"
        height="32.5"
        rx="1.25"
        stroke="url(#paint13_linear_2453_565)"
        strokeWidth="1.5"
      />
      <rect
        x="605.555"
        y="668.25"
        width="32.4612"
        height="32.5"
        rx="1.25"
        stroke="url(#paint14_linear_2453_565)"
        strokeWidth="1.5"
      />
      <mask id="path-224-inside-6_2453_565" fill="white">
        <path d="M438 282.5C438 280.291 439.791 278.496 442 278.536C486.948 279.355 530.597 293.959 567.019 320.421C603.44 346.883 630.818 383.883 645.486 426.378C646.207 428.466 645.054 430.724 642.953 431.407L567.38 455.962C565.279 456.644 563.029 455.492 562.283 453.412C553.339 428.481 537.089 406.783 515.61 391.179C494.132 375.574 468.475 366.824 442 366.022C439.792 365.955 438 364.171 438 361.961L438 282.5Z" />
      </mask>
      <path
        d="M438 282.5C438 280.291 439.791 278.496 442 278.536C486.948 279.355 530.597 293.959 567.019 320.421C603.44 346.883 630.818 383.883 645.486 426.378C646.207 428.466 645.054 430.724 642.953 431.407L567.38 455.962C565.279 456.644 563.029 455.492 562.283 453.412C553.339 428.481 537.089 406.783 515.61 391.179C494.132 375.574 468.475 366.824 442 366.022C439.792 365.955 438 364.171 438 361.961L438 282.5Z"
        fill="#694DBE"
        stroke="#483389"
        strokeWidth="2"
        mask="url(#path-224-inside-6_2453_565)"
      />
      <g filter="url(#filter5_d_2453_565)">
        <ellipse
          cx="182.294"
          cy="412.5"
          rx="41.9521"
          ry="42"
          fill="url(#paint15_linear_2453_565)"
          fillOpacity="0.6"
          shapeRendering="crispEdges"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2453_565"
          x="238.479"
          y="299.485"
          width="407.535"
          height="406.029"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="9" dy="9" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.611765 0 0 0 0 0.305882 0 0 0 0 1 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2453_565" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2453_565" result="shape" />
        </filter>
        <filter
          id="filter1_d_2453_565"
          x="-0.00439453"
          y="557.5"
          width="149.838"
          height="70"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="8" dy="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.611765 0 0 0 0 0.305882 0 0 0 0 1 0 0 0 0.19 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2453_565" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2453_565" result="shape" />
        </filter>
        <filter
          id="filter2_d_2453_565"
          x="647.257"
          y="733.5"
          width="146.842"
          height="70"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="8" dy="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.611765 0 0 0 0 0.305882 0 0 0 0 1 0 0 0 0.19 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2453_565" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2453_565" result="shape" />
        </filter>
        <filter
          id="filter3_d_2453_565"
          x="517.405"
          y="191.5"
          width="193.788"
          height="70"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="8" dy="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.611765 0 0 0 0 0.305882 0 0 0 0 1 0 0 0 0.19 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2453_565" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2453_565" result="shape" />
        </filter>
        <filter
          id="filter4_d_2453_565"
          x="650.973"
          y="499.721"
          width="107.446"
          height="107.56"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="8" dy="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.611765 0 0 0 0 0.305882 0 0 0 0 1 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2453_565" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2453_565" result="shape" />
        </filter>
        <filter
          id="filter5_d_2453_565"
          x="140.342"
          y="370.5"
          width="91.9043"
          height="92"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="8" dy="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.611765 0 0 0 0 0.305882 0 0 0 0 1 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2453_565" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2453_565" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_2453_565"
          x1="-0.221879"
          y1="557.273"
          x2="167.101"
          y2="588.284"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2453_565"
          x1="647.044"
          y1="733.273"
          x2="811.06"
          y2="763.029"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2453_565"
          x1="517.12"
          y1="191.273"
          x2="731.202"
          y2="243.245"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2453_565"
          x1="919.69"
          y1="346.342"
          x2="1026.67"
          y2="379.518"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FA627A" stopOpacity="0.22" />
          <stop offset="0.375" stopColor="#EE4486" stopOpacity="0.51" />
          <stop offset="0.729167" stopColor="#BE6EFE" stopOpacity="0.33" />
          <stop offset="1" stopColor="#676CF4" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_2453_565"
          x1="716.977"
          y1="556"
          x2="881.107"
          y2="606.548"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF5A5A" stopOpacity="0" />
          <stop offset="0.375" stopColor="#EE4486" stopOpacity="0.51" />
          <stop offset="0.729167" stopColor="#BE6EFE" />
          <stop offset="1" stopColor="#676CF4" stopOpacity="0" />
          <stop offset="1" stopColor="#676CF4" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_2453_565"
          x1="785.398"
          y1="-89.3825"
          x2="914.231"
          y2="-49.5222"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FA627A" stopOpacity="0.22" />
          <stop offset="0.375" stopColor="#EE4486" stopOpacity="0.51" />
          <stop offset="0.729167" stopColor="#BE6EFE" stopOpacity="0.33" />
          <stop offset="1" stopColor="#676CF4" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_2453_565"
          x1="225.184"
          y1="288.367"
          x2="268.316"
          y2="291.782"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_2453_565"
          x1="608.65"
          y1="288.37"
          x2="652.769"
          y2="292.029"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_2453_565"
          x1="609.486"
          y1="671.847"
          x2="652.619"
          y2="675.262"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_2453_565"
          x1="225.182"
          y1="672.685"
          x2="269.301"
          y2="676.344"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_2453_565"
          x1="719.134"
          y1="481.186"
          x2="771.049"
          y2="590.55"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_2453_565"
          x1="719.134"
          y1="481.186"
          x2="771.049"
          y2="590.55"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_2453_565"
          x1="719.134"
          y1="481.186"
          x2="771.049"
          y2="590.55"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_2453_565"
          x1="234.176"
          y1="296.376"
          x2="275.346"
          y2="299.707"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_2453_565"
          x1="604.753"
          y1="667.376"
          x2="645.923"
          y2="670.707"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_2453_565"
          x1="140.214"
          y1="370.193"
          x2="241.927"
          y2="378.424"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
